
import { ActivityCategory } from '@/types/program';

export const getCategoryColor = (category: string) => {
  switch (category) {
    case 'warm_up':
      return 'bg-orange-100 text-orange-800';
    case 'drill':
      return 'bg-blue-100 text-blue-800';
    case 'conditioning':
      return 'bg-red-100 text-red-800';
    case 'scrimmage':
      return 'bg-green-100 text-green-800';
    case 'cool_down':
      return 'bg-purple-100 text-purple-800';
    case 'strategy':
      return 'bg-yellow-100 text-yellow-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getCategoryLabel = (category: string) => {
  switch (category) {
    case 'warm_up':
      return 'Warm Up';
    case 'cool_down':
      return 'Cool Down';
    default:
      return category.charAt(0).toUpperCase() + category.slice(1);
  }
};

export const getCategoryTotals = (activities: Array<{ category: string; duration: number }>) => {
  const totals: Record<string, number> = {};
  activities.forEach(activity => {
    totals[activity.category] = (totals[activity.category] || 0) + activity.duration;
  });
  return totals;
};
